import React, { useState, useEffect } from 'react';
import './App.css';
import Hero from './components/Hero';
import GameRules from './components/GameRules';
import Screenshots from './components/Screenshots';
import Download from './components/Download';
import BuyMeCoffee from './components/BuyMeCoffee';
import LanguageSelector from './components/LanguageSelector';
import ScrollIndicator from './components/ScrollIndicator';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App crt-effect">
        <LanguageSelector />
        <Hero />
        <ScrollIndicator />
        <GameRules />
        <Screenshots />
        <Download />
        <BuyMeCoffee />
        <footer className="footer">
          <p>© 2025 Crazy AngryBricks - Tugs - AMSTRAD CPC</p>
        </footer>
      </div>
    </LanguageProvider>
  );
}

export default App;